import React from 'react';

export function AboutSection() {
  return (
    <section id="about-section" className="py-20 bg-blue-50 dark:bg-blue-950/30 relative overflow-hidden box-border">
      <div className="max-w-6xl mx-auto px-4 relative box-border">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-1/3 mb-10 lg:mb-0 flex justify-center lg:justify-start">
            <div className="relative">
              <div className="absolute -top-6 -right-6 w-full h-full border-2 border-[#F37022] rounded-xl"></div>
              <img
                alt="About JD Simplified"
                className="w-64 h-64 object-cover rounded-xl relative z-10"
                data-twic-src="media:images/JD_Simplified_About-Me.jpeg"
                data-twic-transform="quality=95/output=auto"
              />
            </div>
          </div>

          <div className="w-full lg:w-2/3 lg:pl-20">
            <div className="max-w-2xl mx-auto lg:mx-0 px-6 lg:px-0">
              <span className="inline-block bg-[#F37022]/10 text-[#F37022] px-4 py-1 rounded-full text-sm font-medium mb-4">
                ABOUT ME
              </span>
              <h2 className="text-3xl font-bold mb-6 text-[#00178E] dark:text-blue-400">
                J.D. grad specializing in strategy-based legal instruction
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Far too many law school and bar exam courses are unnecessarily complicated, boring, and lacking in quality. I create lectures that are engaging and thorough, yet lean and to the point.
                <br />
                <br />
                I built JD Simplified after surviving law school the hard way — slogging through casebooks, outlines, and overpriced monotonous video lectures that barely scratched the surface of the material. My goal? To give you exactly what you need to master law school and ace the bar exam with minimal pain.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 